export const deviceSize = {
  mobileS: 320,
  mobileSM: 360,
  mobileM: 375,
  mobileMPlus: 411, // Iphone 5/6/7 plus, pixel 2 plus
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopS: 1280,
  laptopM: 1300,
  laptopL: 1440,
  desktopM: 1920,
  desktop: 2560,
};

const size = {
  mobileS: `${deviceSize.mobileS}px`,
  mobileSM: `${deviceSize.mobileSM}px`,
  mobileM: `${deviceSize.mobileM}px`,
  mobileMPlus: `${deviceSize.mobileMPlus}px`,
  mobileL: `${deviceSize.mobileL}px`,
  maxMobileL: `${deviceSize.mobileL + 2}px`,
  maxMobile: `${deviceSize.tablet - 1}px`,
  tablet: `${deviceSize.tablet}px`,
  laptop: `${deviceSize.laptop}px`,
  laptopS: `${deviceSize.laptopS}px`,
  laptopM: `${deviceSize.laptopM}px`,
  laptopL: `${deviceSize.laptopL}px`,
  desktopM: `${deviceSize.desktopM}px`,
  desktop: `${deviceSize.desktop}px`,
};

export const device = {
  mobileS: `min-width: ${size.mobileS}`,
  mobileSLandscape: `screen and (min-device-width:${size.mobileS}) and (orientation:landscape)`,
  mobileSPortrait: `screen and (min-device-width:${size.mobileS}) and (orientation:portrait)`,
  mobileSM: `min-width: ${size.mobileSM}`,
  mobileM: `min-width: ${size.mobileM}`,
  mobileMPlus: `min-width: ${size.mobileMPlus}`,
  mobileL: `min-width: ${size.mobileL}`,
  maxMobileL: `max-width: ${size.maxMobileL}`,
  maxMobile: `max-width: ${size.maxMobile}`,
  tablet: `min-width: ${size.tablet}`,
  laptop: `min-width: ${size.laptop}`,
  laptopS: `min-width: ${size.laptopS}`,
  laptopM: `min-width: ${size.laptopM}`,
  laptopL: `min-width: ${size.laptopL}`,
  desktopM: `min-width: ${size.desktopM}`,
  desktop: `min-width: ${size.desktop}`,
  desktopL: `min-width: ${size.desktop}`,
};
